import { render, staticRenderFns } from "./AddressMy.vue?vue&type=template&id=9a555c0a"
import script from "./AddressMy.vue?vue&type=script&lang=js"
export * from "./AddressMy.vue?vue&type=script&lang=js"
import style0 from "./AddressMy.vue?vue&type=style&index=0&id=9a555c0a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports